import { render, staticRenderFns } from "./person-price.vue?vue&type=template&id=624ef6ec&"
import script from "./person-price.vue?vue&type=script&lang=js&"
export * from "./person-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports